var _toArray = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/toArray.js");

var _defineProperty = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _createClass = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _regeneratorRuntime = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/codebuild/output/src2648725416/src/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.promise.finally.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step3;

    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return to;
};

var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  GraphQLHandler: function GraphQLHandler() {
    return _GraphQLHandler;
  },
  RESTMethods: function RESTMethods() {
    return _RESTMethods;
  },
  RequestHandler: function RequestHandler() {
    return _RequestHandler;
  },
  RestHandler: function RestHandler() {
    return _RestHandler;
  },
  cleanUrl: function cleanUrl() {
    return _cleanUrl;
  },
  compose: function compose() {
    return _compose;
  },
  context: function context() {
    return context_exports;
  },
  createResponseComposition: function createResponseComposition() {
    return _createResponseComposition;
  },
  defaultContext: function defaultContext() {
    return _defaultContext;
  },
  defaultResponse: function defaultResponse() {
    return _defaultResponse;
  },
  graphql: function graphql() {
    return _graphql;
  },
  graphqlContext: function graphqlContext() {
    return _graphqlContext;
  },
  handleRequest: function handleRequest() {
    return _handleRequest;
  },
  matchRequestUrl: function matchRequestUrl() {
    return _matchRequestUrl;
  },
  parseIsomorphicRequest: function parseIsomorphicRequest() {
    return _parseIsomorphicRequest;
  },
  response: function response() {
    return _response;
  },
  rest: function rest() {
    return _rest;
  },
  restContext: function restContext() {
    return _restContext;
  },
  setupWorker: function setupWorker() {
    return _setupWorker;
  }
});

module.exports = __toCommonJS(src_exports); // src/context/index.ts

var context_exports = {};

__export(context_exports, {
  body: function body() {
    return _body;
  },
  cookie: function cookie() {
    return _cookie;
  },
  data: function data() {
    return _data;
  },
  delay: function delay() {
    return _delay;
  },
  errors: function errors() {
    return _errors;
  },
  extensions: function extensions() {
    return _extensions;
  },
  fetch: function fetch() {
    return _fetch;
  },
  json: function json() {
    return _json;
  },
  set: function set() {
    return _set;
  },
  status: function status() {
    return _status;
  },
  text: function text() {
    return _text;
  },
  xml: function xml() {
    return _xml;
  }
}); // src/context/status.ts


var import_codes = __toESM(require("statuses/codes.json"));

var _status = function _status(statusCode, statusText) {
  return function (res) {
    res.status = statusCode;
    res.statusText = statusText || import_codes.default[String(statusCode)];
    return res;
  };
}; // src/context/set.ts


var import_headers_polyfill = require("headers-polyfill");

function _set() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (res) {
    var name = args[0],
        value = args[1];

    if (typeof name === "string") {
      res.headers.append(name, value);
    } else {
      var headers = (0, import_headers_polyfill.objectToHeaders)(name);
      headers.forEach(function (value2, name2) {
        res.headers.append(name2, value2);
      });
    }

    return res;
  };
} // src/context/cookie.ts


var cookieUtils = __toESM(require("cookie"));

var _cookie = function _cookie(name, value, options) {
  return function (res) {
    var serializedCookie = cookieUtils.serialize(name, value, options);
    res.headers.set("Set-Cookie", serializedCookie);

    if (typeof document !== "undefined") {
      document.cookie = serializedCookie;
    }

    return res;
  };
}; // src/context/body.ts


var _body = function _body(value) {
  return function (res) {
    res.body = value;
    return res;
  };
}; // src/utils/internal/jsonParse.ts


function jsonParse(value) {
  try {
    return JSON.parse(value);
  } catch (error2) {
    return void 0;
  }
} // src/utils/internal/isObject.ts


function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
} // src/utils/internal/mergeRight.ts


function mergeRight(left, right) {
  return Object.entries(right).reduce(function (result, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        rightValue = _ref2[1];

    var leftValue = result[key];

    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
      result[key] = leftValue.concat(rightValue);
      return result;
    }

    if (isObject(leftValue) && isObject(rightValue)) {
      result[key] = mergeRight(leftValue, rightValue);
      return result;
    }

    result[key] = rightValue;
    return result;
  }, Object.assign({}, left));
} // src/context/json.ts


var _json = function _json(body2) {
  return function (res) {
    res.headers.set("Content-Type", "application/json");
    res.body = JSON.stringify(body2);
    return res;
  };
}; // src/context/data.ts


var _data = function _data(payload) {
  return function (res) {
    var prevBody = jsonParse(res.body) || {};
    var nextBody = mergeRight(prevBody, {
      data: payload
    });
    return _json(nextBody)(res);
  };
}; // src/context/extensions.ts


var _extensions = function _extensions(payload) {
  return function (res) {
    var prevBody = jsonParse(res.body) || {};
    var nextBody = mergeRight(prevBody, {
      extensions: payload
    });
    return _json(nextBody)(res);
  };
}; // src/context/delay.ts


var import_is_node_process = require("is-node-process");

var SET_TIMEOUT_MAX_ALLOWED_INT = 2147483647;
var MIN_SERVER_RESPONSE_TIME = 100;
var MAX_SERVER_RESPONSE_TIME = 400;
var NODE_SERVER_RESPONSE_TIME = 5;

var getRandomServerResponseTime = function getRandomServerResponseTime() {
  if ((0, import_is_node_process.isNodeProcess)()) {
    return NODE_SERVER_RESPONSE_TIME;
  }

  return Math.floor(Math.random() * (MAX_SERVER_RESPONSE_TIME - MIN_SERVER_RESPONSE_TIME) + MIN_SERVER_RESPONSE_TIME);
};

var _delay = function _delay(durationOrMode) {
  return function (res) {
    var delayTime;

    if (typeof durationOrMode === "string") {
      switch (durationOrMode) {
        case "infinite":
          {
            delayTime = SET_TIMEOUT_MAX_ALLOWED_INT;
            break;
          }

        case "real":
          {
            delayTime = getRandomServerResponseTime();
            break;
          }

        default:
          {
            throw new Error("Failed to delay a response: unknown delay mode \"".concat(durationOrMode, "\". Please make sure you provide one of the supported modes (\"real\", \"infinite\") or a number to \"ctx.delay\"."));
          }
      }
    } else if (typeof durationOrMode === "undefined") {
      delayTime = getRandomServerResponseTime();
    } else {
      if (durationOrMode > SET_TIMEOUT_MAX_ALLOWED_INT) {
        throw new Error("Failed to delay a response: provided delay duration (".concat(durationOrMode, ") exceeds the maximum allowed duration for \"setTimeout\" (").concat(SET_TIMEOUT_MAX_ALLOWED_INT, "). This will cause the response to be returned immediately. Please use a number within the allowed range to delay the response by exact duration, or consider the \"infinite\" delay mode to delay the response indefinitely."));
      }

      delayTime = durationOrMode;
    }

    res.delay = delayTime;
    return res;
  };
}; // src/context/errors.ts


var _errors = function _errors(errorsList) {
  return function (res) {
    if (errorsList == null) {
      return res;
    }

    var prevBody = jsonParse(res.body) || {};
    var nextBody = mergeRight(prevBody, {
      errors: errorsList
    });
    return _json(nextBody)(res);
  };
}; // src/context/fetch.ts


var import_is_node_process2 = require("is-node-process");

var import_headers_polyfill2 = require("headers-polyfill");

var useFetch = (0, import_is_node_process2.isNodeProcess)() ? require("node-fetch") : window.fetch;

var augmentRequestInit = function augmentRequestInit(requestInit) {
  var headers = new import_headers_polyfill2.Headers(requestInit.headers);
  headers.set("x-msw-bypass", "true");
  return __spreadProps(__spreadValues({}, requestInit), {
    headers: headers.all()
  });
};

var createFetchRequestParameters = function createFetchRequestParameters(input) {
  var body2 = input.body,
      method = input.method;

  var requestParameters = __spreadProps(__spreadValues({}, input), {
    body: void 0
  });

  if (["GET", "HEAD"].includes(method)) {
    return requestParameters;
  }

  if (typeof body2 === "object" || typeof body2 === "number" || typeof body2 === "boolean") {
    requestParameters.body = JSON.stringify(body2);
  } else {
    requestParameters.body = body2;
  }

  return requestParameters;
};

var _fetch = function _fetch(input) {
  var requestInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof input === "string") {
    return useFetch(input, augmentRequestInit(requestInit));
  }

  var requestParameters = createFetchRequestParameters(input);
  var derivedRequestInit = augmentRequestInit(requestParameters);
  return useFetch(input.url.href, derivedRequestInit);
}; // src/context/text.ts


var _text = function _text(body2) {
  return function (res) {
    res.headers.set("Content-Type", "text/plain");
    res.body = body2;
    return res;
  };
}; // src/context/xml.ts


var _xml = function _xml(body2) {
  return function (res) {
    res.headers.set("Content-Type", "text/xml");
    res.body = body2;
    return res;
  };
}; // src/setupWorker/setupWorker.ts


var import_is_node_process3 = require("is-node-process");

var import_strict_event_emitter = require("strict-event-emitter"); // src/setupWorker/start/createStartHandler.ts


var import_until4 = require("@open-draft/until"); // src/setupWorker/start/utils/getWorkerInstance.ts


var import_until = require("@open-draft/until"); // src/setupWorker/start/utils/getWorkerByRegistration.ts


var getWorkerByRegistration = function getWorkerByRegistration(registration, absoluteWorkerUrl, findWorker) {
  var allStates = [registration.active, registration.installing, registration.waiting];
  var existingStates = allStates.filter(Boolean);
  var mockWorker = existingStates.find(function (worker) {
    return findWorker(worker.scriptURL, absoluteWorkerUrl);
  });
  return mockWorker || null;
}; // src/utils/url/getAbsoluteWorkerUrl.ts


function getAbsoluteWorkerUrl(relativeUrl) {
  return new URL(relativeUrl, location.origin).href;
} // src/utils/internal/devUtils.ts


var import_outvariant = require("outvariant");

var LIBRARY_PREFIX = "[MSW]";

function formatMessage(message) {
  for (var _len2 = arguments.length, positionals = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    positionals[_key2 - 1] = arguments[_key2];
  }

  var interpolatedMessage = (0, import_outvariant.format).apply(void 0, [message].concat(positionals));
  return "".concat(LIBRARY_PREFIX, " ").concat(interpolatedMessage);
}

function warn(message) {
  for (var _len3 = arguments.length, positionals = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    positionals[_key3 - 1] = arguments[_key3];
  }

  console.warn(formatMessage.apply(void 0, [message].concat(positionals)));
}

function error(message) {
  for (var _len4 = arguments.length, positionals = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    positionals[_key4 - 1] = arguments[_key4];
  }

  console.error(formatMessage.apply(void 0, [message].concat(positionals)));
}

var devUtils = {
  formatMessage: formatMessage,
  warn: warn,
  error: error
}; // src/setupWorker/start/utils/getWorkerInstance.ts

var getWorkerInstance = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
    var options,
        findWorker,
        absoluteWorkerUrl,
        mockRegistrations,
        _mockRegistrations,
        existingRegistration,
        _yield,
        _yield2,
        error2,
        instance,
        isWorkerMissing,
        scopeUrl,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          findWorker = _args2.length > 2 ? _args2[2] : undefined;
          absoluteWorkerUrl = getAbsoluteWorkerUrl(url);
          _context2.next = 5;
          return navigator.serviceWorker.getRegistrations().then(function (registrations) {
            return registrations.filter(function (registration) {
              return getWorkerByRegistration(registration, absoluteWorkerUrl, findWorker);
            });
          });

        case 5:
          mockRegistrations = _context2.sent;

          if (!navigator.serviceWorker.controller && mockRegistrations.length > 0) {
            location.reload();
          }

          _mockRegistrations = _slicedToArray(mockRegistrations, 1), existingRegistration = _mockRegistrations[0];

          if (!existingRegistration) {
            _context2.next = 10;
            break;
          }

          return _context2.abrupt("return", existingRegistration.update().then(function () {
            return [getWorkerByRegistration(existingRegistration, absoluteWorkerUrl, findWorker), existingRegistration];
          }));

        case 10:
          _context2.next = 12;
          return (0, import_until.until)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var registration;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return navigator.serviceWorker.register(url, options);

                case 2:
                  registration = _context.sent;
                  return _context.abrupt("return", [getWorkerByRegistration(registration, absoluteWorkerUrl, findWorker), registration]);

                case 4:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })));

        case 12:
          _yield = _context2.sent;
          _yield2 = _slicedToArray(_yield, 2);
          error2 = _yield2[0];
          instance = _yield2[1];

          if (!error2) {
            _context2.next = 22;
            break;
          }

          isWorkerMissing = error2.message.includes("(404)");

          if (!isWorkerMissing) {
            _context2.next = 21;
            break;
          }

          scopeUrl = new URL((options == null ? void 0 : options.scope) || "/", location.href);
          throw new Error(devUtils.formatMessage("Failed to register a Service Worker for scope ('".concat(scopeUrl.href, "') with script ('").concat(absoluteWorkerUrl, "'): Service Worker script does not exist at the given path.\n\nDid you forget to run \"npx msw init <PUBLIC_DIR>\"?\n\nLearn more about creating the Service Worker script: https://mswjs.io/docs/cli/init")));

        case 21:
          throw new Error(devUtils.formatMessage("Failed to register the Service Worker:\n\n%s", error2.message));

        case 22:
          return _context2.abrupt("return", instance);

        case 23:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function getWorkerInstance(_x) {
    return _ref3.apply(this, arguments);
  };
}(); // src/setupWorker/start/utils/printStartMessage.ts


function printStartMessage() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (args.quiet) {
    return;
  }

  var message = args.message || "Mocking enabled.";
  console.groupCollapsed("%c".concat(devUtils.formatMessage(message)), "color:orangered;font-weight:bold;");
  console.log("%cDocumentation: %chttps://mswjs.io/docs", "font-weight:bold", "font-weight:normal");
  console.log("Found an issue? https://github.com/mswjs/msw/issues");

  if (args.workerUrl) {
    console.log("Worker script URL:", args.workerUrl);
  }

  if (args.workerScope) {
    console.log("Worker scope:", args.workerScope);
  }

  console.groupEnd();
} // src/setupWorker/start/utils/enableMocking.ts


function enableMocking(_x2, _x3) {
  return _enableMocking.apply(this, arguments);
} // src/utils/createBroadcastChannel.ts


function _enableMocking() {
  _enableMocking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(context, options) {
    var _a, _b;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          context.workerChannel.send("MOCK_ACTIVATE");
          _context14.next = 3;
          return context.events.once("MOCKING_ENABLED");

        case 3:
          if (!context.isMockingEnabled) {
            _context14.next = 6;
            break;
          }

          devUtils.warn("Found a redundant \"worker.start()\" call. Note that starting the worker while mocking is already enabled will have no effect. Consider removing this \"worker.start()\" call.");
          return _context14.abrupt("return");

        case 6:
          context.isMockingEnabled = true;
          printStartMessage({
            quiet: options.quiet,
            workerScope: (_a = context.registration) == null ? void 0 : _a.scope,
            workerUrl: (_b = context.worker) == null ? void 0 : _b.scriptURL
          });

        case 8:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _enableMocking.apply(this, arguments);
}

var createBroadcastChannel = function createBroadcastChannel(event) {
  var port = event.ports[0];
  return {
    send: function send(message) {
      if (port) {
        port.postMessage(message);
      }
    }
  };
}; // src/utils/NetworkError.ts


var NetworkError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(NetworkError, _Error);

  var _super = _createSuper(NetworkError);

  function NetworkError(message) {
    var _this;

    _classCallCheck(this, NetworkError);

    _this = _super.call(this, message);
    _this.name = "NetworkError";
    return _this;
  }

  return _createClass(NetworkError);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // src/utils/request/parseWorkerRequest.ts


var import_headers_polyfill6 = require("headers-polyfill"); // src/handlers/RequestHandler.ts


var import_headers_polyfill4 = require("headers-polyfill"); // src/response.ts


var import_headers_polyfill3 = require("headers-polyfill"); // src/utils/internal/compose.ts


function _compose() {
  for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    fns[_key5] = arguments[_key5];
  }

  return function () {
    return fns.reduceRight(function (leftFn, rightFn) {
      return leftFn instanceof Promise ? Promise.resolve(leftFn).then(rightFn) : rightFn(leftFn);
    }, arguments.length <= 0 ? undefined : arguments[0]);
  };
} // src/response.ts


var _defaultResponse = {
  status: 200,
  statusText: "OK",
  body: null,
  delay: 0,
  once: false,
  passthrough: false
};
var defaultResponseTransformers = [];

function _createResponseComposition(responseOverrides) {
  var defaultTransformers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultResponseTransformers;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var initialResponse,
        _len6,
        transformers,
        _key6,
        resolvedTransformers,
        resolvedResponse,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          initialResponse = Object.assign({}, _defaultResponse, {
            headers: new import_headers_polyfill3.Headers({
              "x-powered-by": "msw"
            })
          }, responseOverrides);

          for (_len6 = _args3.length, transformers = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            transformers[_key6] = _args3[_key6];
          }

          resolvedTransformers = [].concat(_toConsumableArray(defaultTransformers), transformers).filter(Boolean);
          resolvedResponse = resolvedTransformers.length > 0 ? _compose.apply(void 0, _toConsumableArray(resolvedTransformers))(initialResponse) : initialResponse;
          return _context3.abrupt("return", resolvedResponse);

        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
}

var _response = Object.assign(_createResponseComposition(), {
  once: _createResponseComposition({
    once: true
  }),
  networkError: function networkError(message) {
    throw new NetworkError(message);
  }
}); // src/utils/internal/getCallFrame.ts


var SOURCE_FRAME = /\/msw\/src\/(.+)/;
var BUILD_FRAME = /(node_modules)?[\/\\]lib[\/\\](umd|esm|iief|cjs)[\/\\]|^[^\/\\]*$/;

function getCallFrame(error2) {
  var stack = error2.stack;

  if (!stack) {
    return;
  }

  var frames = stack.split("\n").slice(1);
  var declarationFrame = frames.find(function (frame) {
    return !(SOURCE_FRAME.test(frame) || BUILD_FRAME.test(frame));
  });

  if (!declarationFrame) {
    return;
  }

  var declarationPath = declarationFrame.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "");
  return declarationPath;
} // src/utils/internal/isIterable.ts


function isIterable(fn) {
  if (!fn) {
    return false;
  }

  return typeof fn[Symbol.iterator] == "function";
} // src/handlers/RequestHandler.ts


var _defaultContext = {
  status: _status,
  set: _set,
  delay: _delay,
  fetch: _fetch
};

var _RequestHandler = /*#__PURE__*/function () {
  "use strict";

  function _RequestHandler(options) {
    _classCallCheck(this, _RequestHandler);

    this.shouldSkip = false;
    this.ctx = options.ctx || _defaultContext;
    this.resolver = options.resolver;
    var callFrame = getCallFrame(new Error());
    this.info = __spreadProps(__spreadValues({}, options.info), {
      callFrame: callFrame
    });
  }

  _createClass(_RequestHandler, [{
    key: "parse",
    value: function parse(_request, _resolutionContext) {
      return null;
    }
  }, {
    key: "test",
    value: function test(request, resolutionContext) {
      return this.predicate(request, this.parse(request, resolutionContext), resolutionContext);
    }
  }, {
    key: "getPublicRequest",
    value: function getPublicRequest(request, _parsedResult) {
      return request;
    }
  }, {
    key: "markAsSkipped",
    value: function markAsSkipped() {
      var shouldSkip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.shouldSkip = shouldSkip;
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(request, resolutionContext) {
        var parsedResult, shouldIntercept, publicRequest, executeResolver, mockedResponse;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.shouldSkip) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return", null);

            case 2:
              parsedResult = this.parse(request, resolutionContext);
              shouldIntercept = this.predicate(request, parsedResult, resolutionContext);

              if (shouldIntercept) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", null);

            case 6:
              publicRequest = this.getPublicRequest(request, parsedResult);
              executeResolver = this.wrapResolver(this.resolver);
              _context4.next = 10;
              return executeResolver(publicRequest, _response, this.ctx);

            case 10:
              mockedResponse = _context4.sent;
              return _context4.abrupt("return", this.createExecutionResult(parsedResult, publicRequest, mockedResponse));

            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));

      function run(_x4, _x5) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "wrapResolver",
    value: function wrapResolver(resolver) {
      var _this2 = this;

      return /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(req, res, ctx) {
          var result, _result$Symbol$iterat2, value, done, nextResponse;

          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = _this2.resolverGenerator;

                if (_context5.t0) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return resolver(req, res, ctx);

              case 4:
                _context5.t0 = _context5.sent;

              case 5:
                result = _context5.t0;

                if (!isIterable(result)) {
                  _context5.next = 16;
                  break;
                }

                _result$Symbol$iterat2 = result[Symbol.iterator]().next(), value = _result$Symbol$iterat2.value, done = _result$Symbol$iterat2.done;
                _context5.next = 10;
                return value;

              case 10:
                nextResponse = _context5.sent;

                if (!(!nextResponse && done)) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt("return", _this2.resolverGeneratorResult);

              case 13:
                if (!_this2.resolverGenerator) {
                  _this2.resolverGenerator = result;
                }

                _this2.resolverGeneratorResult = nextResponse;
                return _context5.abrupt("return", nextResponse);

              case 16:
                return _context5.abrupt("return", result);

              case 17:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));

        return function (_x6, _x7, _x8) {
          return _ref6.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "createExecutionResult",
    value: function createExecutionResult(parsedResult, request, response2) {
      return {
        handler: this,
        parsedResult: parsedResult || null,
        request: request,
        response: response2 || null
      };
    }
  }]);

  return _RequestHandler;
}();

function passthrough() {
  return {
    status: 101,
    statusText: "Continue",
    headers: new import_headers_polyfill4.Headers(),
    body: null,
    passthrough: true,
    once: false
  };
} // src/utils/request/setRequestCookies.ts


var cookieUtils3 = __toESM(require("cookie"));

var import_cookies = require("@mswjs/cookies"); // src/utils/request/getRequestCookies.ts


var cookieUtils2 = __toESM(require("cookie"));

function getAllCookies() {
  return cookieUtils2.parse(document.cookie);
}

function getRequestCookies(request) {
  if (typeof document === "undefined" || typeof location === "undefined") {
    return {};
  }

  switch (request.credentials) {
    case "same-origin":
      {
        return location.origin === request.url.origin ? getAllCookies() : {};
      }

    case "include":
      {
        return getAllCookies();
      }

    default:
      {
        return {};
      }
  }
} // src/utils/request/setRequestCookies.ts


function setRequestCookies(request) {
  var _a;

  var requestCookiesString = request.headers.get("cookie");
  import_cookies.store.hydrate();
  var cookiesFromStore = Array.from((_a = import_cookies.store.get(__spreadProps(__spreadValues({}, request), {
    url: request.url.toString()
  }))) == null ? void 0 : _a.entries()).reduce(function (cookies, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        name = _ref8[0],
        value = _ref8[1].value;

    return Object.assign(cookies, _defineProperty({}, name.trim(), value));
  }, {});
  var cookiesFromDocument = getRequestCookies(request);

  var forwardedCookies = __spreadValues(__spreadValues({}, cookiesFromDocument), cookiesFromStore);

  for (var _i = 0, _Object$entries = Object.entries(forwardedCookies); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i2 = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i2[0],
        value = _Object$entries$_i2[1];

    request.headers.append("cookie", "".concat(name, "=").concat(value));
  }

  var ownCookies = requestCookiesString ? cookieUtils3.parse(requestCookiesString) : {};
  request.cookies = __spreadValues(__spreadValues(__spreadValues({}, request.cookies), forwardedCookies), ownCookies);
} // src/utils/internal/parseMultipartData.ts


var import_headers_polyfill5 = require("headers-polyfill");

function parseContentHeaders(headersString) {
  var _a, _b;

  var headers = (0, import_headers_polyfill5.stringToHeaders)(headersString);
  var contentType = headers.get("content-type") || "text/plain";
  var disposition = headers.get("content-disposition");

  if (!disposition) {
    throw new Error('"Content-Disposition" header is required.');
  }

  var directives = disposition.split(";").reduce(function (acc, chunk) {
    var _chunk$trim$split = chunk.trim().split("="),
        _chunk$trim$split2 = _toArray(_chunk$trim$split),
        name2 = _chunk$trim$split2[0],
        rest2 = _chunk$trim$split2.slice(1);

    acc[name2] = rest2.join("=");
    return acc;
  }, {});
  var name = (_a = directives.name) == null ? void 0 : _a.slice(1, -1);
  var filename = (_b = directives.filename) == null ? void 0 : _b.slice(1, -1);
  return {
    name: name,
    filename: filename,
    contentType: contentType
  };
}

function parseMultipartData(data2, headers) {
  var contentType = headers == null ? void 0 : headers.get("content-type");

  if (!contentType) {
    return void 0;
  }

  var _contentType$split = contentType.split(/; */),
      _contentType$split2 = _toArray(_contentType$split),
      directives = _contentType$split2.slice(1);

  var boundary = directives.filter(function (d) {
    return d.startsWith("boundary=");
  }).map(function (s) {
    return s.replace(/^boundary=/, "");
  })[0];

  if (!boundary) {
    return void 0;
  }

  var boundaryRegExp = new RegExp("--+".concat(boundary));
  var fields = data2.split(boundaryRegExp).filter(function (chunk) {
    return chunk.startsWith("\r\n") && chunk.endsWith("\r\n");
  }).map(function (chunk) {
    return chunk.trimStart().replace(/\r\n$/, "");
  });

  if (!fields.length) {
    return void 0;
  }

  var parsedBody = {};

  try {
    var _iterator4 = _createForOfIteratorHelper(fields),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var field2 = _step4.value;

        var _field2$split3 = field2.split("\r\n\r\n"),
            _field2$split4 = _toArray(_field2$split3),
            contentHeaders = _field2$split4[0],
            rest2 = _field2$split4.slice(1);

        var contentBody = rest2.join("\r\n\r\n");

        var _parseContentHeaders2 = parseContentHeaders(contentHeaders),
            contentType2 = _parseContentHeaders2.contentType,
            filename = _parseContentHeaders2.filename,
            name = _parseContentHeaders2.name;

        var value = filename === void 0 ? contentBody : new File([contentBody], filename, {
          type: contentType2
        });
        var parsedValue = parsedBody[name];

        if (parsedValue === void 0) {
          parsedBody[name] = value;
        } else if (Array.isArray(parsedValue)) {
          parsedBody[name] = [].concat(_toConsumableArray(parsedValue), [value]);
        } else {
          parsedBody[name] = [parsedValue, value];
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return parsedBody;
  } catch (error2) {
    return void 0;
  }
} // src/utils/request/parseBody.ts


function parseBody(body2, headers) {
  var _a;

  if (!body2) {
    return body2;
  }

  var contentType = ((_a = headers == null ? void 0 : headers.get("content-type")) == null ? void 0 : _a.toLowerCase()) || "";
  var hasMultipartContent = contentType.startsWith("multipart/form-data");

  if (hasMultipartContent && typeof body2 !== "object") {
    return parseMultipartData(body2.toString(), headers) || body2;
  }

  var hasJsonContent = contentType.includes("json");

  if (hasJsonContent && typeof body2 !== "object") {
    return jsonParse(body2.toString()) || body2;
  }

  return body2;
} // src/utils/internal/isStringEqual.ts


function isStringEqual(actual, expected) {
  return actual.toLowerCase() === expected.toLowerCase();
} // src/utils/request/pruneGetRequestBody.ts


function pruneGetRequestBody(request) {
  if (request.method && isStringEqual(request.method, "GET") && request.body === "") {
    return void 0;
  }

  return request.body;
} // src/utils/request/parseWorkerRequest.ts


function parseWorkerRequest(rawRequest) {
  var request = {
    id: rawRequest.id,
    cache: rawRequest.cache,
    credentials: rawRequest.credentials,
    method: rawRequest.method,
    url: new URL(rawRequest.url),
    referrer: rawRequest.referrer,
    referrerPolicy: rawRequest.referrerPolicy,
    redirect: rawRequest.redirect,
    mode: rawRequest.mode,
    params: {},
    cookies: {},
    integrity: rawRequest.integrity,
    keepalive: rawRequest.keepalive,
    destination: rawRequest.destination,
    body: pruneGetRequestBody(rawRequest),
    bodyUsed: rawRequest.bodyUsed,
    headers: new import_headers_polyfill6.Headers(rawRequest.headers),
    passthrough: passthrough
  };
  setRequestCookies(request);
  request.body = parseBody(request.body, request.headers);
  return request;
} // src/utils/handleRequest.ts


var import_until2 = require("@open-draft/until"); // src/utils/getResponse.ts


var getResponse = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(request, handlers, resolutionContext) {
    var relevantHandlers, result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          relevantHandlers = handlers.filter(function (handler) {
            return handler.test(request, resolutionContext);
          });

          if (!(relevantHandlers.length === 0)) {
            _context7.next = 3;
            break;
          }

          return _context7.abrupt("return", {
            handler: void 0,
            response: void 0
          });

        case 3:
          _context7.next = 5;
          return relevantHandlers.reduce( /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(executionResult, handler) {
              var previousResults, result2;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return executionResult;

                  case 2:
                    previousResults = _context6.sent;

                    if (!(previousResults == null ? void 0 : previousResults.response)) {
                      _context6.next = 5;
                      break;
                    }

                    return _context6.abrupt("return", executionResult);

                  case 5:
                    _context6.next = 7;
                    return handler.run(request, resolutionContext);

                  case 7:
                    result2 = _context6.sent;

                    if (!(result2 === null || result2.handler.shouldSkip)) {
                      _context6.next = 10;
                      break;
                    }

                    return _context6.abrupt("return", null);

                  case 10:
                    if (result2.response) {
                      _context6.next = 12;
                      break;
                    }

                    return _context6.abrupt("return", {
                      request: result2.request,
                      handler: result2.handler,
                      response: void 0,
                      parsedResult: result2.parsedResult
                    });

                  case 12:
                    if (result2.response.once) {
                      handler.markAsSkipped(true);
                    }

                    return _context6.abrupt("return", result2);

                  case 14:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6);
            }));

            return function (_x12, _x13) {
              return _ref10.apply(this, arguments);
            };
          }(), Promise.resolve(null));

        case 5:
          result = _context7.sent;

          if (result) {
            _context7.next = 8;
            break;
          }

          return _context7.abrupt("return", {
            handler: void 0,
            response: void 0
          });

        case 8:
          return _context7.abrupt("return", {
            handler: result.handler,
            publicRequest: result.request,
            parsedRequest: result.parsedResult,
            response: result.response
          });

        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));

  return function getResponse(_x9, _x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}(); // src/utils/request/onUnhandledRequest.ts


var import_js_levenshtein = __toESM(require("js-levenshtein")); // src/utils/internal/parseGraphQLRequest.ts


var import_graphql = require("graphql"); // src/utils/request/getPublicUrlFromRequest.ts


var getPublicUrlFromRequest = function getPublicUrlFromRequest(request) {
  return request.referrer.startsWith(request.url.origin) ? request.url.pathname : new URL(request.url.pathname, "".concat(request.url.protocol, "//").concat(request.url.host)).href;
}; // src/utils/internal/parseGraphQLRequest.ts


function parseDocumentNode(node) {
  var _a;

  var operationDef = node.definitions.find(function (def) {
    return def.kind === "OperationDefinition";
  });
  return {
    operationType: operationDef == null ? void 0 : operationDef.operation,
    operationName: (_a = operationDef == null ? void 0 : operationDef.name) == null ? void 0 : _a.value
  };
}

function parseQuery(query) {
  try {
    var ast = (0, import_graphql.parse)(query);
    return parseDocumentNode(ast);
  } catch (error2) {
    return error2;
  }
}

function extractMultipartVariables(variables, map, files) {
  var operations = {
    variables: variables
  };

  for (var _i2 = 0, _Object$entries2 = Object.entries(map); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i2 = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i2[0],
        pathArray = _Object$entries2$_i2[1];

    if (!(key in files)) {
      throw new Error("Given files do not have a key '".concat(key, "' ."));
    }

    var _iterator5 = _createForOfIteratorHelper(pathArray),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var dotPath = _step5.value;

        var _dotPath$split$revers3 = dotPath.split(".").reverse(),
            _dotPath$split$revers4 = _toArray(_dotPath$split$revers3),
            lastPath = _dotPath$split$revers4[0],
            reversedPaths = _dotPath$split$revers4.slice(1);

        var paths = reversedPaths.reverse();
        var target = operations;

        var _iterator6 = _createForOfIteratorHelper(paths),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var path = _step6.value;

            if (!(path in target)) {
              throw new Error("Property '".concat(paths, "' is not in operations."));
            }

            target = target[path];
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        target[lastPath] = files[key];
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return operations.variables;
}

function getGraphQLInput(request) {
  var _a, _b;

  switch (request.method) {
    case "GET":
      {
        var query = request.url.searchParams.get("query");
        var variables = request.url.searchParams.get("variables") || "";
        return {
          query: query,
          variables: jsonParse(variables)
        };
      }

    case "POST":
      {
        if ((_a = request.body) == null ? void 0 : _a.query) {
          var _request$body2 = request.body,
              _query = _request$body2.query,
              _variables = _request$body2.variables;
          return {
            query: _query,
            variables: _variables
          };
        }

        if ((_b = request.body) == null ? void 0 : _b.operations) {
          var _c = request.body,
              operations = _c.operations,
              map = _c.map,
              files = __objRest(_c, ["operations", "map"]);

          var parsedOperations = jsonParse(operations) || {};

          if (!parsedOperations.query) {
            return null;
          }

          var parsedMap = jsonParse(map || "") || {};

          var _variables2 = parsedOperations.variables ? extractMultipartVariables(parsedOperations.variables, parsedMap, files) : {};

          return {
            query: parsedOperations.query,
            variables: _variables2
          };
        }
      }

    default:
      return null;
  }
}

function parseGraphQLRequest(request) {
  var input = getGraphQLInput(request);

  if (!input || !input.query) {
    return void 0;
  }

  var query = input.query,
      variables = input.variables;
  var parsedResult = parseQuery(query);

  if (parsedResult instanceof Error) {
    var requestPublicUrl = getPublicUrlFromRequest(request);
    throw new Error(devUtils.formatMessage('Failed to intercept a GraphQL request to "%s %s": cannot parse query. See the error message from the parser below.\n\n%s', request.method, requestPublicUrl, parsedResult.message));
  }

  return {
    operationType: parsedResult.operationType,
    operationName: parsedResult.operationName,
    variables: variables
  };
} // src/utils/logging/getStatusCodeColor.ts


function getStatusCodeColor(status2) {
  if (status2 < 300) {
    return "#69AB32"
    /* Success */
    ;
  }

  if (status2 < 400) {
    return "#F0BB4B"
    /* Warning */
    ;
  }

  return "#E95F5D"
  /* Danger */
  ;
} // src/utils/logging/getTimestamp.ts


function getTimestamp() {
  var now = new Date();
  return [now.getHours(), now.getMinutes(), now.getSeconds()].map(String).map(function (chunk) {
    return chunk.slice(0, 2);
  }).map(function (chunk) {
    return chunk.padStart(2, "0");
  }).join(":");
} // src/utils/logging/prepareRequest.ts


function prepareRequest(request) {
  return __spreadProps(__spreadValues({}, request), {
    headers: request.headers.all()
  });
} // src/utils/logging/prepareResponse.ts


var import_headers_polyfill7 = require("headers-polyfill");

function prepareResponse(res) {
  var responseHeaders = (0, import_headers_polyfill7.objectToHeaders)(res.headers);
  return __spreadProps(__spreadValues({}, res), {
    body: parseBody(res.body, responseHeaders)
  });
} // src/utils/matching/matchRequestUrl.ts


var import_path_to_regexp = require("path-to-regexp");

var import_getCleanUrl = require("@mswjs/interceptors/lib/utils/getCleanUrl"); // src/utils/url/cleanUrl.ts


var REDUNDANT_CHARACTERS_EXP = /[\?|#].*$/g;

function getSearchParams(path) {
  return new URL("/".concat(path), "http://localhost").searchParams;
}

function _cleanUrl(path) {
  return path.replace(REDUNDANT_CHARACTERS_EXP, "");
} // src/utils/url/isAbsoluteUrl.ts


function isAbsoluteUrl(url) {
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
} // src/utils/url/getAbsoluteUrl.ts


function getAbsoluteUrl(path, baseUrl) {
  if (isAbsoluteUrl(path)) {
    return path;
  }

  if (path.startsWith("*")) {
    return path;
  }

  var origin = baseUrl || typeof document !== "undefined" && document.baseURI;
  return origin ? decodeURI(new URL(encodeURI(path), origin).href) : path;
} // src/utils/matching/normalizePath.ts


function normalizePath(path, baseUrl) {
  if (path instanceof RegExp) {
    return path;
  }

  var maybeAbsoluteUrl = getAbsoluteUrl(path, baseUrl);
  return _cleanUrl(maybeAbsoluteUrl);
} // src/utils/matching/matchRequestUrl.ts


function coercePath(path) {
  return path.replace(/([:a-zA-Z_-]*)(\*{1,2})+/g, function (_, parameterName, wildcard) {
    var expression = "(.*)";

    if (!parameterName) {
      return expression;
    }

    return parameterName.startsWith(":") ? "".concat(parameterName).concat(wildcard) : "".concat(parameterName).concat(expression);
  }).replace(/([^\/])(:)(?=\d+)/, "$1\\$2").replace(/^([^\/]+)(:)(?=\/\/)/, "$1\\$2");
}

function _matchRequestUrl(url, path, baseUrl) {
  var normalizedPath = normalizePath(path, baseUrl);
  var cleanPath = typeof normalizedPath === "string" ? coercePath(normalizedPath) : normalizedPath;
  var cleanUrl2 = (0, import_getCleanUrl.getCleanUrl)(url);
  var result = (0, import_path_to_regexp.match)(cleanPath, {
    decode: decodeURIComponent
  })(cleanUrl2);
  var params = result && result.params || {};
  return {
    matches: result !== false,
    params: params
  };
} // src/handlers/RestHandler.ts


var _RESTMethods = /* @__PURE__ */function (RESTMethods2) {
  RESTMethods2["HEAD"] = "HEAD";
  RESTMethods2["GET"] = "GET";
  RESTMethods2["POST"] = "POST";
  RESTMethods2["PUT"] = "PUT";
  RESTMethods2["PATCH"] = "PATCH";
  RESTMethods2["OPTIONS"] = "OPTIONS";
  RESTMethods2["DELETE"] = "DELETE";
  return RESTMethods2;
}(_RESTMethods || {});

var _restContext = __spreadProps(__spreadValues({}, _defaultContext), {
  cookie: _cookie,
  body: _body,
  text: _text,
  json: _json,
  xml: _xml
});

var _RestHandler = /*#__PURE__*/function (_RequestHandler2) {
  "use strict";

  _inherits(_RestHandler, _RequestHandler2);

  var _super2 = _createSuper(_RestHandler);

  function _RestHandler(method, path, resolver) {
    var _this3;

    _classCallCheck(this, _RestHandler);

    _this3 = _super2.call(this, {
      info: {
        header: "".concat(method, " ").concat(path),
        path: path,
        method: method
      },
      ctx: _restContext,
      resolver: resolver
    });

    _this3.checkRedundantQueryParameters();

    return _this3;
  }

  _createClass(_RestHandler, [{
    key: "checkRedundantQueryParameters",
    value: function checkRedundantQueryParameters() {
      var _this$info = this.info,
          method = _this$info.method,
          path = _this$info.path;

      if (path instanceof RegExp) {
        return;
      }

      var url = _cleanUrl(path);

      if (url === path) {
        return;
      }

      var searchParams = getSearchParams(path);
      var queryParams = [];
      searchParams.forEach(function (_, paramName) {
        queryParams.push(paramName);
      });
      devUtils.warn("Found a redundant usage of query parameters in the request handler URL for \"".concat(method, " ").concat(path, "\". Please match against a path instead and access query parameters in the response resolver function using \"req.url.searchParams\"."));
    }
  }, {
    key: "parse",
    value: function parse(request, resolutionContext) {
      return _matchRequestUrl(request.url, this.info.path, resolutionContext == null ? void 0 : resolutionContext.baseUrl);
    }
  }, {
    key: "getPublicRequest",
    value: function getPublicRequest(request, parsedResult) {
      return __spreadProps(__spreadValues({}, request), {
        params: parsedResult.params || {}
      });
    }
  }, {
    key: "predicate",
    value: function predicate(request, parsedResult) {
      var matchesMethod = this.info.method instanceof RegExp ? this.info.method.test(request.method) : isStringEqual(this.info.method, request.method);
      return matchesMethod && parsedResult.matches;
    }
  }, {
    key: "log",
    value: function log(request, response2) {
      var publicUrl = getPublicUrlFromRequest(request);
      var loggedRequest = prepareRequest(request);
      var loggedResponse = prepareResponse(response2);
      var statusColor = getStatusCodeColor(response2.status);
      console.groupCollapsed(devUtils.formatMessage("%s %s %s (%c%s%c)"), getTimestamp(), request.method, publicUrl, "color:".concat(statusColor), "".concat(response2.status, " ").concat(response2.statusText), "color:inherit");
      console.log("Request", loggedRequest);
      console.log("Handler:", {
        mask: this.info.path,
        resolver: this.resolver
      });
      console.log("Response", loggedResponse);
      console.groupEnd();
    }
  }]);

  return _RestHandler;
}(_RequestHandler); // src/context/field.ts


var import_outvariant2 = require("outvariant");

var field = function field(fieldName, fieldValue) {
  return function (res) {
    validateFieldName(fieldName);
    var prevBody = jsonParse(res.body) || {};
    var nextBody = mergeRight(prevBody, _defineProperty({}, fieldName, fieldValue));
    return _json(nextBody)(res);
  };
};

function validateFieldName(fieldName) {
  (0, import_outvariant2.invariant)(fieldName.trim() !== "", devUtils.formatMessage("Failed to set a custom field on a GraphQL response: field name cannot be empty."));
  (0, import_outvariant2.invariant)(fieldName !== "data", devUtils.formatMessage('Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.data()" instead?', fieldName));
  (0, import_outvariant2.invariant)(fieldName !== "errors", devUtils.formatMessage('Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.errors()" instead?', fieldName));
  (0, import_outvariant2.invariant)(fieldName !== "extensions", devUtils.formatMessage('Failed to set a custom "%s" field on a mocked GraphQL response: forbidden field name. Did you mean to call "ctx.extensions()" instead?', fieldName));
} // src/utils/internal/tryCatch.ts


function tryCatch(fn, onException) {
  try {
    var result = fn();
    return result;
  } catch (error2) {
    onException == null ? void 0 : onException(error2);
  }
} // src/handlers/GraphQLHandler.ts


var _graphqlContext = __spreadProps(__spreadValues({}, _defaultContext), {
  data: _data,
  extensions: _extensions,
  errors: _errors,
  cookie: _cookie,
  field: field
});

function isDocumentNode(value) {
  if (value == null) {
    return false;
  }

  return typeof value === "object" && "kind" in value && "definitions" in value;
}

var _GraphQLHandler = /*#__PURE__*/function (_RequestHandler3) {
  "use strict";

  _inherits(_GraphQLHandler, _RequestHandler3);

  var _super3 = _createSuper(_GraphQLHandler);

  function _GraphQLHandler(operationType, operationName, endpoint, resolver) {
    var _this4;

    _classCallCheck(this, _GraphQLHandler);

    var resolvedOperationName = operationName;

    if (isDocumentNode(operationName)) {
      var parsedNode = parseDocumentNode(operationName);

      if (parsedNode.operationType !== operationType) {
        throw new Error("Failed to create a GraphQL handler: provided a DocumentNode with a mismatched operation type (expected \"".concat(operationType, "\", but got \"").concat(parsedNode.operationType, "\")."));
      }

      if (!parsedNode.operationName) {
        throw new Error("Failed to create a GraphQL handler: provided a DocumentNode with no operation name.");
      }

      resolvedOperationName = parsedNode.operationName;
    }

    var header = operationType === "all" ? "".concat(operationType, " (origin: ").concat(endpoint.toString(), ")") : "".concat(operationType, " ").concat(resolvedOperationName, " (origin: ").concat(endpoint.toString(), ")");
    _this4 = _super3.call(this, {
      info: {
        header: header,
        operationType: operationType,
        operationName: resolvedOperationName
      },
      ctx: _graphqlContext,
      resolver: resolver
    });
    _this4.endpoint = endpoint;
    return _this4;
  }

  _createClass(_GraphQLHandler, [{
    key: "parse",
    value: function parse(request) {
      return tryCatch(function () {
        return parseGraphQLRequest(request);
      }, function (error2) {
        return console.error(error2.message);
      });
    }
  }, {
    key: "getPublicRequest",
    value: function getPublicRequest(request, parsedResult) {
      return __spreadProps(__spreadValues({}, request), {
        variables: (parsedResult == null ? void 0 : parsedResult.variables) || {}
      });
    }
  }, {
    key: "predicate",
    value: function predicate(request, parsedResult) {
      if (!parsedResult) {
        return false;
      }

      if (!parsedResult.operationName && this.info.operationType !== "all") {
        var publicUrl = getPublicUrlFromRequest(request);
        devUtils.warn("Failed to intercept a GraphQL request at \"".concat(request.method, " ").concat(publicUrl, "\": anonymous GraphQL operations are not supported.\n\nConsider naming this operation or using \"graphql.operation\" request handler to intercept GraphQL requests regardless of their operation name/type. Read more: https://mswjs.io/docs/api/graphql/operation      "));
        return false;
      }

      var hasMatchingUrl = _matchRequestUrl(request.url, this.endpoint);

      var hasMatchingOperationType = this.info.operationType === "all" || parsedResult.operationType === this.info.operationType;
      var hasMatchingOperationName = this.info.operationName instanceof RegExp ? this.info.operationName.test(parsedResult.operationName || "") : parsedResult.operationName === this.info.operationName;
      return hasMatchingUrl.matches && hasMatchingOperationType && hasMatchingOperationName;
    }
  }, {
    key: "log",
    value: function log(request, response2, handler, parsedRequest) {
      var loggedRequest = prepareRequest(request);
      var loggedResponse = prepareResponse(response2);
      var statusColor = getStatusCodeColor(response2.status);
      var requestInfo = (parsedRequest == null ? void 0 : parsedRequest.operationName) ? "".concat(parsedRequest == null ? void 0 : parsedRequest.operationType, " ").concat(parsedRequest == null ? void 0 : parsedRequest.operationName) : "anonymous ".concat(parsedRequest == null ? void 0 : parsedRequest.operationType);
      console.groupCollapsed(devUtils.formatMessage("%s %s (%c%s%c)"), getTimestamp(), "".concat(requestInfo), "color:".concat(statusColor), "".concat(response2.status, " ").concat(response2.statusText), "color:inherit");
      console.log("Request:", loggedRequest);
      console.log("Handler:", this);
      console.log("Response:", loggedResponse);
      console.groupEnd();
    }
  }]);

  return _GraphQLHandler;
}(_RequestHandler); // src/utils/request/onUnhandledRequest.ts


var MAX_MATCH_SCORE = 3;
var MAX_SUGGESTION_COUNT = 4;
var TYPE_MATCH_DELTA = 0.5;

function groupHandlersByType(handlers) {
  return handlers.reduce(function (groups, handler) {
    if (handler instanceof _RestHandler) {
      groups.rest.push(handler);
    }

    if (handler instanceof _GraphQLHandler) {
      groups.graphql.push(handler);
    }

    return groups;
  }, {
    rest: [],
    graphql: []
  });
}

function getRestHandlerScore() {
  return function (request, handler) {
    var _handler$info = handler.info,
        path = _handler$info.path,
        method = _handler$info.method;

    if (path instanceof RegExp || method instanceof RegExp) {
      return Infinity;
    }

    var hasSameMethod = isStringEqual(request.method, method);
    var methodScoreDelta = hasSameMethod ? TYPE_MATCH_DELTA : 0;
    var requestPublicUrl = getPublicUrlFromRequest(request);
    var score = (0, import_js_levenshtein.default)(requestPublicUrl, path);
    return score - methodScoreDelta;
  };
}

function getGraphQLHandlerScore(parsedQuery) {
  return function (_, handler) {
    if (typeof parsedQuery.operationName === "undefined") {
      return Infinity;
    }

    var _handler$info2 = handler.info,
        operationType = _handler$info2.operationType,
        operationName = _handler$info2.operationName;

    if (typeof operationName !== "string") {
      return Infinity;
    }

    var hasSameOperationType = parsedQuery.operationType === operationType;
    var operationTypeScoreDelta = hasSameOperationType ? TYPE_MATCH_DELTA : 0;
    var score = (0, import_js_levenshtein.default)(parsedQuery.operationName, operationName);
    return score - operationTypeScoreDelta;
  };
}

function getSuggestedHandler(request, handlers, getScore) {
  var suggestedHandlers = handlers.reduce(function (suggestions, handler) {
    var score = getScore(request, handler);
    return suggestions.concat([[score, handler]]);
  }, []).sort(function (_ref11, _ref12) {
    var _ref13 = _slicedToArray(_ref11, 1),
        leftScore = _ref13[0];

    var _ref14 = _slicedToArray(_ref12, 1),
        rightScore = _ref14[0];

    return leftScore - rightScore;
  }).filter(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 1),
        score = _ref16[0];

    return score <= MAX_MATCH_SCORE;
  }).slice(0, MAX_SUGGESTION_COUNT).map(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
        handler = _ref18[1];

    return handler;
  });
  return suggestedHandlers;
}

function getSuggestedHandlersMessage(handlers) {
  if (handlers.length > 1) {
    return "Did you mean to request one of the following resources instead?\n\n".concat(handlers.map(function (handler) {
      return "  \u2022 ".concat(handler.info.header);
    }).join("\n"));
  }

  return "Did you mean to request \"".concat(handlers[0].info.header, "\" instead?");
}

function onUnhandledRequest(request, handlers) {
  var strategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "warn";
  var parsedGraphQLQuery = tryCatch(function () {
    return parseGraphQLRequest(request);
  });

  function generateHandlerSuggestion() {
    var handlerGroups = groupHandlersByType(handlers);
    var relevantHandlers = parsedGraphQLQuery ? handlerGroups.graphql : handlerGroups.rest;
    var suggestedHandlers = getSuggestedHandler(request, relevantHandlers, parsedGraphQLQuery ? getGraphQLHandlerScore(parsedGraphQLQuery) : getRestHandlerScore());
    return suggestedHandlers.length > 0 ? getSuggestedHandlersMessage(suggestedHandlers) : "";
  }

  function generateUnhandledRequestMessage() {
    var publicUrl = getPublicUrlFromRequest(request);
    var requestHeader = parsedGraphQLQuery ? "".concat(parsedGraphQLQuery.operationType, " ").concat(parsedGraphQLQuery.operationName, " (").concat(request.method, " ").concat(publicUrl, ")") : "".concat(request.method, " ").concat(publicUrl);
    var handlerSuggestion = generateHandlerSuggestion();
    var messageTemplate = ["captured a request without a matching request handler:", "  \u2022 ".concat(requestHeader), handlerSuggestion, "If you still wish to intercept this unhandled request, please create a request handler for it.\nRead more: https://mswjs.io/docs/getting-started/mocks"].filter(Boolean);
    return messageTemplate.join("\n\n");
  }

  function applyStrategy(strategy2) {
    var message = generateUnhandledRequestMessage();

    switch (strategy2) {
      case "error":
        {
          devUtils.error("Error: %s", message);
          throw new Error(devUtils.formatMessage('Cannot bypass a request when using the "error" strategy for the "onUnhandledRequest" option.'));
        }

      case "warn":
        {
          devUtils.warn("Warning: %s", message);
          break;
        }

      case "bypass":
        break;

      default:
        throw new Error(devUtils.formatMessage('Failed to react to an unhandled request: unknown strategy "%s". Please provide one of the supported strategies ("bypass", "warn", "error") or a custom callback function as the value of the "onUnhandledRequest" option.', strategy2));
    }
  }

  if (typeof strategy === "function") {
    strategy(request, {
      warning: applyStrategy.bind(null, "warn"),
      error: applyStrategy.bind(null, "error")
    });
    return;
  }

  applyStrategy(strategy);
} // src/utils/request/readResponseCookies.ts


var import_cookies2 = require("@mswjs/cookies");

function readResponseCookies(request, response2) {
  import_cookies2.store.add(__spreadProps(__spreadValues({}, request), {
    url: request.url.toString()
  }), response2);
  import_cookies2.store.persist();
} // src/utils/handleRequest.ts


function _handleRequest(_x14, _x15, _x16, _x17, _x18) {
  return _handleRequest2.apply(this, arguments);
} // src/utils/worker/createRequestListener.ts


function _handleRequest2() {
  _handleRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(request, handlers, options, emitter, handleRequestOptions) {
    var _a, _b, _c, _d, _e, _f, _g, _yield5, _yield6, lookupError, lookupResult, handler, response2, requiredLookupResult, transformedResponse;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          emitter.emit("request:start", request);

          if (!(request.headers.get("x-msw-bypass") === "true")) {
            _context15.next = 5;
            break;
          }

          emitter.emit("request:end", request);
          (_a = handleRequestOptions == null ? void 0 : handleRequestOptions.onPassthroughResponse) == null ? void 0 : _a.call(handleRequestOptions, request);
          return _context15.abrupt("return");

        case 5:
          _context15.next = 7;
          return (0, import_until2.until)(function () {
            return getResponse(request, handlers, handleRequestOptions == null ? void 0 : handleRequestOptions.resolutionContext);
          });

        case 7:
          _yield5 = _context15.sent;
          _yield6 = _slicedToArray(_yield5, 2);
          lookupError = _yield6[0];
          lookupResult = _yield6[1];

          if (!lookupError) {
            _context15.next = 14;
            break;
          }

          emitter.emit("unhandledException", lookupError, request);
          throw lookupError;

        case 14:
          handler = lookupResult.handler, response2 = lookupResult.response;

          if (handler) {
            _context15.next = 21;
            break;
          }

          onUnhandledRequest(request, handlers, options.onUnhandledRequest);
          emitter.emit("request:unhandled", request);
          emitter.emit("request:end", request);
          (_b = handleRequestOptions == null ? void 0 : handleRequestOptions.onPassthroughResponse) == null ? void 0 : _b.call(handleRequestOptions, request);
          return _context15.abrupt("return");

        case 21:
          if (response2) {
            _context15.next = 26;
            break;
          }

          devUtils.warn("Expected response resolver to return a mocked response Object, but got %s. The original response is going to be used instead.\n\n  \u2022 %s\n    %s", response2, handler.info.header, handler.info.callFrame);
          emitter.emit("request:end", request);
          (_c = handleRequestOptions == null ? void 0 : handleRequestOptions.onPassthroughResponse) == null ? void 0 : _c.call(handleRequestOptions, request);
          return _context15.abrupt("return");

        case 26:
          if (!response2.passthrough) {
            _context15.next = 30;
            break;
          }

          emitter.emit("request:end", request);
          (_d = handleRequestOptions == null ? void 0 : handleRequestOptions.onPassthroughResponse) == null ? void 0 : _d.call(handleRequestOptions, request);
          return _context15.abrupt("return");

        case 30:
          readResponseCookies(request, response2);
          emitter.emit("request:match", request);
          requiredLookupResult = lookupResult;
          transformedResponse = ((_e = handleRequestOptions == null ? void 0 : handleRequestOptions.transformResponse) == null ? void 0 : _e.call(handleRequestOptions, response2)) || response2;
          (_f = handleRequestOptions == null ? void 0 : handleRequestOptions.onMockedResponse) == null ? void 0 : _f.call(handleRequestOptions, transformedResponse, requiredLookupResult);
          (_g = handleRequestOptions == null ? void 0 : handleRequestOptions.onMockedResponseSent) == null ? void 0 : _g.call(handleRequestOptions, transformedResponse, requiredLookupResult);
          emitter.emit("request:end", request);
          return _context15.abrupt("return", transformedResponse);

        case 38:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _handleRequest2.apply(this, arguments);
}

var createRequestListener = function createRequestListener(context, options) {
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(event, message) {
      var channel, request;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            channel = createBroadcastChannel(event);
            _context8.prev = 1;
            request = parseWorkerRequest(message.payload);
            _context8.next = 5;
            return _handleRequest(request, context.requestHandlers, options, context.emitter, {
              transformResponse: transformResponse,
              onPassthroughResponse: function onPassthroughResponse() {
                return channel.send({
                  type: "MOCK_NOT_FOUND"
                });
              },
              onMockedResponse: function onMockedResponse(response2) {
                channel.send({
                  type: "MOCK_SUCCESS",
                  payload: response2
                });
              },
              onMockedResponseSent: function onMockedResponseSent(response2, _ref20) {
                var handler = _ref20.handler,
                    publicRequest = _ref20.publicRequest,
                    parsedRequest = _ref20.parsedRequest;

                if (options.quiet) {
                  return;
                }

                handler.log(publicRequest, response2, handler, parsedRequest);
              }
            });

          case 5:
            _context8.next = 12;
            break;

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](1);

            if (!(_context8.t0 instanceof NetworkError)) {
              _context8.next = 11;
              break;
            }

            return _context8.abrupt("return", channel.send({
              type: "NETWORK_ERROR",
              payload: {
                name: _context8.t0.name,
                message: _context8.t0.message
              }
            }));

          case 11:
            if (_context8.t0 instanceof Error) {
              channel.send({
                type: "INTERNAL_ERROR",
                payload: {
                  status: 500,
                  body: JSON.stringify({
                    errorType: _context8.t0.constructor.name,
                    message: _context8.t0.message,
                    location: _context8.t0.stack
                  })
                }
              });
            }

          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[1, 7]]);
    }));

    return function (_x19, _x20) {
      return _ref19.apply(this, arguments);
    };
  }();
};

function transformResponse(response2) {
  return {
    status: response2.status,
    statusText: response2.statusText,
    headers: response2.headers.all(),
    body: response2.body,
    delay: response2.delay
  };
} // src/utils/internal/requestIntegrityCheck.ts


function requestIntegrityCheck(_x21, _x22) {
  return _requestIntegrityCheck.apply(this, arguments);
} // src/utils/deferNetworkRequestsUntil.ts


function _requestIntegrityCheck() {
  _requestIntegrityCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(context, serviceWorker) {
    var _yield$context$events, actualChecksum;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          context.workerChannel.send("INTEGRITY_CHECK_REQUEST");
          _context16.next = 3;
          return context.events.once("INTEGRITY_CHECK_RESPONSE");

        case 3:
          _yield$context$events = _context16.sent;
          actualChecksum = _yield$context$events.payload;

          if (!(actualChecksum !== "02f4ad4a2797f85668baf196e553d929")) {
            _context16.next = 7;
            break;
          }

          throw new Error("Currently active Service Worker (".concat(actualChecksum, ") is behind the latest published one (", "02f4ad4a2797f85668baf196e553d929", ")."));

        case 7:
          return _context16.abrupt("return", serviceWorker);

        case 8:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _requestIntegrityCheck.apply(this, arguments);
}

var import_until3 = require("@open-draft/until");

function deferNetworkRequestsUntil(predicatePromise) {
  var originalXhrSend = window.XMLHttpRequest.prototype.send;

  window.XMLHttpRequest.prototype.send = function () {
    var _this5 = this;

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    (0, import_until3.until)(function () {
      return predicatePromise;
    }).then(function () {
      window.XMLHttpRequest.prototype.send = originalXhrSend;

      _this5.send.apply(_this5, args);
    });
  };

  var originalFetch = window.fetch;
  window.fetch = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var _window;

    var _args9 = arguments;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, import_until3.until)(function () {
            return predicatePromise;
          });

        case 2:
          window.fetch = originalFetch;
          return _context9.abrupt("return", (_window = window).fetch.apply(_window, _args9));

        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
} // src/utils/worker/createResponseListener.ts


function createResponseListener(context) {
  return function (_, message) {
    var _a;

    var responseJson = message.payload;

    if ((_a = responseJson.type) == null ? void 0 : _a.includes("opaque")) {
      return;
    }

    var response2 = new Response(responseJson.body || null, responseJson);
    var isMockedResponse = response2.headers.get("x-powered-by") === "msw";

    if (isMockedResponse) {
      context.emitter.emit("response:mocked", response2, responseJson.requestId);
    } else {
      context.emitter.emit("response:bypass", response2, responseJson.requestId);
    }
  };
} // src/setupWorker/start/utils/validateWorkerScope.ts


function validateWorkerScope(registration, options) {
  if (!(options == null ? void 0 : options.quiet) && !location.href.startsWith(registration.scope)) {
    devUtils.warn("Cannot intercept requests on this page because it's outside of the worker's scope (\"".concat(registration.scope, "\"). If you wish to mock API requests on this page, you must resolve this scope issue.\n\n- (Recommended) Register the worker at the root level (\"/\") of your application.\n- Set the \"Service-Worker-Allowed\" response header to allow out-of-scope workers."));
  }
} // src/setupWorker/start/createStartHandler.ts


var createStartHandler = function createStartHandler(context) {
  return function start(options, customOptions) {
    var startWorkerInstance = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var instance, _instance, worker, registration, missingWorkerMessage, _yield3, _yield4, integrityError;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              context.events.removeAllListeners();
              context.workerChannel.on("REQUEST", createRequestListener(context, options));
              context.workerChannel.on("RESPONSE", createResponseListener(context));
              _context10.next = 5;
              return getWorkerInstance(options.serviceWorker.url, options.serviceWorker.options, options.findWorker);

            case 5:
              instance = _context10.sent;
              _instance = _slicedToArray(instance, 2), worker = _instance[0], registration = _instance[1];

              if (worker) {
                _context10.next = 10;
                break;
              }

              missingWorkerMessage = (customOptions == null ? void 0 : customOptions.findWorker) ? devUtils.formatMessage("Failed to locate the Service Worker registration using a custom \"findWorker\" predicate.\n\nPlease ensure that the custom predicate properly locates the Service Worker registration at \"%s\".\nMore details: https://mswjs.io/docs/api/setup-worker/start#findworker\n", options.serviceWorker.url) : devUtils.formatMessage("Failed to locate the Service Worker registration.\n\nThis most likely means that the worker script URL \"%s\" cannot resolve against the actual public hostname (%s). This may happen if your application runs behind a proxy, or has a dynamic hostname.\n\nPlease consider using a custom \"serviceWorker.url\" option to point to the actual worker script location, or a custom \"findWorker\" option to resolve the Service Worker registration manually. More details: https://mswjs.io/docs/api/setup-worker/start", options.serviceWorker.url, location.host);
              throw new Error(missingWorkerMessage);

            case 10:
              context.worker = worker;
              context.registration = registration;
              context.events.addListener(window, "beforeunload", function () {
                if (worker.state !== "redundant") {
                  context.workerChannel.send("CLIENT_CLOSED");
                }

                window.clearInterval(context.keepAliveInterval);
              });
              _context10.next = 15;
              return (0, import_until4.until)(function () {
                return requestIntegrityCheck(context, worker);
              });

            case 15:
              _yield3 = _context10.sent;
              _yield4 = _slicedToArray(_yield3, 1);
              integrityError = _yield4[0];

              if (integrityError) {
                devUtils.error("Detected outdated Service Worker: ".concat(integrityError.message, "\n\nThe mocking is still enabled, but it's highly recommended that you update your Service Worker by running:\n\n$ npx msw init <PUBLIC_DIR>\n\nThis is necessary to ensure that the Service Worker is in sync with the library to guarantee its stability.\nIf this message still persists after updating, please report an issue: https://github.com/open-draft/msw/issues      "));
              }

              context.keepAliveInterval = window.setInterval(function () {
                return context.workerChannel.send("KEEPALIVE_REQUEST");
              }, 5e3);
              validateWorkerScope(registration, context.startOptions);
              return _context10.abrupt("return", registration);

            case 22:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));

      return function startWorkerInstance() {
        return _ref22.apply(this, arguments);
      };
    }();

    var workerRegistration = startWorkerInstance().then( /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(registration) {
        var pendingInstance;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              pendingInstance = registration.installing || registration.waiting;

              if (!pendingInstance) {
                _context11.next = 4;
                break;
              }

              _context11.next = 4;
              return new Promise(function (resolve) {
                pendingInstance.addEventListener("statechange", function () {
                  if (pendingInstance.state === "activated") {
                    return resolve();
                  }
                });
              });

            case 4:
              _context11.next = 6;
              return enableMocking(context, options).catch(function (error2) {
                throw new Error("Failed to enable mocking: ".concat(error2 == null ? void 0 : error2.message));
              });

            case 6:
              return _context11.abrupt("return", registration);

            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));

      return function (_x23) {
        return _ref23.apply(this, arguments);
      };
    }());

    if (options.waitUntilReady) {
      deferNetworkRequestsUntil(workerRegistration);
    }

    return workerRegistration;
  };
}; // src/setupWorker/stop/utils/printStopMessage.ts


function printStopMessage() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (args.quiet) {
    return;
  }

  console.log("%c".concat(devUtils.formatMessage("Mocking disabled.")), "color:orangered;font-weight:bold;");
} // src/setupWorker/stop/createStop.ts


var createStop = function createStop(context) {
  return function stop() {
    var _a;

    if (!context.isMockingEnabled) {
      devUtils.warn('Found a redundant "worker.stop()" call. Note that stopping the worker while mocking already stopped has no effect. Consider removing this "worker.stop()" call.');
      return;
    }

    context.workerChannel.send("MOCK_DEACTIVATE");
    context.isMockingEnabled = false;
    window.clearInterval(context.keepAliveInterval);
    printStopMessage({
      quiet: (_a = context.startOptions) == null ? void 0 : _a.quiet
    });
  };
}; // src/utils/internal/requestHandlerUtils.ts


function _use(currentHandlers) {
  for (var _len8 = arguments.length, handlers = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
    handlers[_key8 - 1] = arguments[_key8];
  }

  currentHandlers.unshift.apply(currentHandlers, handlers);
}

function _restoreHandlers(handlers) {
  handlers.forEach(function (handler) {
    handler.markAsSkipped(false);
  });
}

function _resetHandlers(initialHandlers) {
  for (var _len9 = arguments.length, nextHandlers = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
    nextHandlers[_key9 - 1] = arguments[_key9];
  }

  return nextHandlers.length > 0 ? [].concat(nextHandlers) : _toConsumableArray(initialHandlers);
} // src/setupWorker/start/utils/prepareStartHandler.ts


var DEFAULT_START_OPTIONS = {
  serviceWorker: {
    url: "/mockServiceWorker.js",
    options: null
  },
  quiet: false,
  waitUntilReady: true,
  onUnhandledRequest: "warn",
  findWorker: function findWorker(scriptURL, mockServiceWorkerUrl) {
    return scriptURL === mockServiceWorkerUrl;
  }
};

function resolveStartOptions(initialOptions) {
  return mergeRight(DEFAULT_START_OPTIONS, initialOptions || {});
}

function prepareStartHandler(handler, context) {
  return function (initialOptions) {
    context.startOptions = resolveStartOptions(initialOptions);
    return handler(context.startOptions, initialOptions || {});
  };
} // src/utils/worker/createFallbackRequestListener.ts


var import_interceptors = require("@mswjs/interceptors");

var import_fetch3 = require("@mswjs/interceptors/lib/interceptors/fetch");

var import_XMLHttpRequest = require("@mswjs/interceptors/lib/interceptors/XMLHttpRequest"); // src/utils/request/parseIsomorphicRequest.ts


function _parseIsomorphicRequest(request) {
  var mockedRequest = {
    id: request.id,
    url: request.url,
    method: request.method,
    body: parseBody(request.body, request.headers),
    credentials: request.credentials || "same-origin",
    headers: request.headers,
    cookies: {},
    redirect: "manual",
    referrer: "",
    keepalive: false,
    cache: "default",
    mode: "cors",
    referrerPolicy: "no-referrer",
    integrity: "",
    destination: "document",
    bodyUsed: false,
    passthrough: passthrough
  };
  setRequestCookies(mockedRequest);
  return mockedRequest;
} // src/utils/worker/createFallbackRequestListener.ts


function createFallbackRequestListener(context, options) {
  var interceptor = new import_interceptors.BatchInterceptor({
    name: "fallback",
    interceptors: [new import_fetch3.FetchInterceptor(), new import_XMLHttpRequest.XMLHttpRequestInterceptor()]
  });
  interceptor.on("request", /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(request) {
      var mockedRequest, response2;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            mockedRequest = _parseIsomorphicRequest(request);
            _context12.next = 3;
            return _handleRequest(mockedRequest, context.requestHandlers, options, context.emitter, {
              transformResponse: function transformResponse(response3) {
                return {
                  status: response3.status,
                  statusText: response3.statusText,
                  headers: response3.headers.all(),
                  body: response3.body,
                  delay: response3.delay
                };
              },
              onMockedResponseSent: function onMockedResponseSent(response3, _ref25) {
                var handler = _ref25.handler,
                    publicRequest = _ref25.publicRequest,
                    parsedRequest = _ref25.parsedRequest;

                if (!options.quiet) {
                  handler.log(publicRequest, response3, handler, parsedRequest);
                }
              }
            });

          case 3:
            response2 = _context12.sent;

            if (response2) {
              request.respondWith(response2);
            }

          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));

    return function (_x24) {
      return _ref24.apply(this, arguments);
    };
  }());
  interceptor.apply();
  return interceptor;
} // src/setupWorker/start/createFallbackStart.ts


function createFallbackStart(context) {
  return /*#__PURE__*/function () {
    var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(options) {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            context.fallbackInterceptor = createFallbackRequestListener(context, options);
            printStartMessage({
              message: "Mocking enabled (fallback mode).",
              quiet: options.quiet
            });
            return _context13.abrupt("return", void 0);

          case 3:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));

    function start(_x25) {
      return _start.apply(this, arguments);
    }

    return start;
  }();
} // src/setupWorker/stop/createFallbackStop.ts


function createFallbackStop(context) {
  return function stop() {
    var _a, _b;

    (_a = context.fallbackInterceptor) == null ? void 0 : _a.dispose();
    printStopMessage({
      quiet: (_b = context.startOptions) == null ? void 0 : _b.quiet
    });
  };
} // src/utils/internal/pipeEvents.ts


function pipeEvents(source, destination) {
  var rawEmit = source.emit;

  if (rawEmit._isPiped) {
    return;
  }

  source.emit = function (event) {
    for (var _len10 = arguments.length, data2 = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
      data2[_key10 - 1] = arguments[_key10];
    }

    destination.emit.apply(destination, [event].concat(data2));
    return rawEmit.call.apply(rawEmit, [this, event].concat(data2));
  };

  source.emit._isPiped = true;
} // src/setupWorker/setupWorker.ts


var listeners = [];

function _setupWorker() {
  for (var _len11 = arguments.length, requestHandlers = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    requestHandlers[_key11] = arguments[_key11];
  }

  requestHandlers.forEach(function (handler) {
    if (Array.isArray(handler)) throw new Error(devUtils.formatMessage('Failed to call "setupWorker" given an Array of request handlers (setupWorker([a, b])), expected to receive each handler individually: setupWorker(a, b).'));
  });

  if ((0, import_is_node_process3.isNodeProcess)()) {
    throw new Error(devUtils.formatMessage("Failed to execute `setupWorker` in a non-browser environment. Consider using `setupServer` for Node.js environment instead."));
  }

  var emitter = new import_strict_event_emitter.StrictEventEmitter();
  var publicEmitter = new import_strict_event_emitter.StrictEventEmitter();
  pipeEvents(emitter, publicEmitter);
  var context = {
    isMockingEnabled: false,
    startOptions: void 0,
    worker: null,
    registration: null,
    requestHandlers: [].concat(requestHandlers),
    emitter: emitter,
    workerChannel: {
      on: function on(eventType, callback) {
        context.events.addListener(navigator.serviceWorker, "message", function (event) {
          if (event.source !== context.worker) {
            return;
          }

          var message = jsonParse(event.data);

          if (!message) {
            return;
          }

          if (message.type === eventType) {
            callback(event, message);
          }
        });
      },
      send: function send(type) {
        var _a;

        (_a = context.worker) == null ? void 0 : _a.postMessage(type);
      }
    },
    events: {
      addListener: function addListener(target, eventType, callback) {
        target.addEventListener(eventType, callback);
        listeners.push({
          eventType: eventType,
          target: target,
          callback: callback
        });
        return function () {
          target.removeEventListener(eventType, callback);
        };
      },
      removeAllListeners: function removeAllListeners() {
        var _iterator7 = _createForOfIteratorHelper(listeners),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _step7$value2 = _step7.value,
                target = _step7$value2.target,
                eventType = _step7$value2.eventType,
                callback = _step7$value2.callback;
            target.removeEventListener(eventType, callback);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        listeners = [];
      },
      once: function once(eventType) {
        var bindings = [];
        return new Promise(function (resolve, reject) {
          var handleIncomingMessage = function handleIncomingMessage(event) {
            try {
              var message = JSON.parse(event.data);

              if (message.type === eventType) {
                resolve(message);
              }
            } catch (error2) {
              reject(error2);
            }
          };

          bindings.push(context.events.addListener(navigator.serviceWorker, "message", handleIncomingMessage), context.events.addListener(navigator.serviceWorker, "messageerror", reject));
        }).finally(function () {
          bindings.forEach(function (unbind) {
            return unbind();
          });
        });
      }
    },
    useFallbackMode: !("serviceWorker" in navigator) || location.protocol === "file:"
  };
  var startHandler = context.useFallbackMode ? createFallbackStart(context) : createStartHandler(context);
  var stopHandler = context.useFallbackMode ? createFallbackStop(context) : createStop(context);
  return {
    start: prepareStartHandler(startHandler, context),
    stop: function stop() {
      context.events.removeAllListeners();
      context.emitter.removeAllListeners();
      publicEmitter.removeAllListeners();
      stopHandler();
    },
    use: function use() {
      for (var _len12 = arguments.length, handlers = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        handlers[_key12] = arguments[_key12];
      }

      _use.apply(void 0, [context.requestHandlers].concat(handlers));
    },
    restoreHandlers: function restoreHandlers() {
      _restoreHandlers(context.requestHandlers);
    },
    resetHandlers: function resetHandlers() {
      for (var _len13 = arguments.length, nextHandlers = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        nextHandlers[_key13] = arguments[_key13];
      }

      context.requestHandlers = _resetHandlers.apply(void 0, [requestHandlers].concat(nextHandlers));
    },
    printHandlers: function printHandlers() {
      context.requestHandlers.forEach(function (handler) {
        var _handler$info3 = handler.info,
            header = _handler$info3.header,
            callFrame = _handler$info3.callFrame;
        var pragma = handler.info.hasOwnProperty("operationType") ? "[graphql]" : "[rest]";
        console.groupCollapsed("".concat(pragma, " ").concat(header));

        if (callFrame) {
          console.log("Declaration: ".concat(callFrame));
        }

        console.log("Handler:", handler);

        if (handler instanceof _RestHandler) {
          console.log("Match:", "https://mswjs.io/repl?path=".concat(handler.info.path));
        }

        console.groupEnd();
      });
    },
    events: {
      on: function on() {
        return publicEmitter.on.apply(publicEmitter, arguments);
      },
      removeListener: function removeListener() {
        return publicEmitter.removeListener.apply(publicEmitter, arguments);
      },
      removeAllListeners: function removeAllListeners() {
        return publicEmitter.removeAllListeners.apply(publicEmitter, arguments);
      }
    }
  };
} // src/rest.ts


function createRestHandler(method) {
  return function (path, resolver) {
    return new _RestHandler(method, path, resolver);
  };
}

var _rest = {
  all: createRestHandler(/.+/),
  head: createRestHandler("HEAD"
  /* HEAD */
  ),
  get: createRestHandler("GET"
  /* GET */
  ),
  post: createRestHandler("POST"
  /* POST */
  ),
  put: createRestHandler("PUT"
  /* PUT */
  ),
  delete: createRestHandler("DELETE"
  /* DELETE */
  ),
  patch: createRestHandler("PATCH"
  /* PATCH */
  ),
  options: createRestHandler("OPTIONS"
  /* OPTIONS */
  )
}; // src/graphql.ts

var import_graphql2 = require("graphql");

function createScopedGraphQLHandler(operationType, url) {
  return function (operationName, resolver) {
    return new _GraphQLHandler(operationType, operationName, url, resolver);
  };
}

function createGraphQLOperationHandler(url) {
  return function (resolver) {
    return new _GraphQLHandler("all", new RegExp(".*"), url, resolver);
  };
}

var standardGraphQLHandlers = {
  operation: createGraphQLOperationHandler("*"),
  query: createScopedGraphQLHandler(import_graphql2.OperationTypeNode.QUERY, "*"),
  mutation: createScopedGraphQLHandler(import_graphql2.OperationTypeNode.MUTATION, "*")
};

function createGraphQLLink(url) {
  return {
    operation: createGraphQLOperationHandler(url),
    query: createScopedGraphQLHandler(import_graphql2.OperationTypeNode.QUERY, url),
    mutation: createScopedGraphQLHandler(import_graphql2.OperationTypeNode.MUTATION, url)
  };
}

var _graphql = __spreadProps(__spreadValues({}, standardGraphQLHandlers), {
  link: createGraphQLLink
}); // Annotate the CommonJS export names for ESM import in node:


0 && (module.exports = {
  GraphQLHandler: _GraphQLHandler,
  RESTMethods: _RESTMethods,
  RequestHandler: _RequestHandler,
  RestHandler: _RestHandler,
  cleanUrl: _cleanUrl,
  compose: _compose,
  context: context,
  createResponseComposition: _createResponseComposition,
  defaultContext: _defaultContext,
  defaultResponse: _defaultResponse,
  graphql: _graphql,
  graphqlContext: _graphqlContext,
  handleRequest: _handleRequest,
  matchRequestUrl: _matchRequestUrl,
  parseIsomorphicRequest: _parseIsomorphicRequest,
  response: _response,
  rest: _rest,
  restContext: _restContext,
  setupWorker: _setupWorker
});